export const UPDATE_EMPLOYEE_SUCCESS = 'UPDATE_EMPLOYEE_SUCCESS';

export const updateEmployeeSuccess = ({ employee }) => ({
    type: UPDATE_EMPLOYEE_SUCCESS,
    payload: {
        employee,
    },
});
